/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { observable, action, runInAction } from 'mobx';
import { inject, injectable, optional } from 'inversify';
import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

import { Invoice } from '../model/invoice';
import { InvoicesByLocation } from '../model/invoicesByLocation';
import { ProjectSignatureRequest } from '../model/projectSignatureRequest';
import { SignInvoiceRequest } from '../model/signInvoiceRequest';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration, ErrorStatusMap, ExtraAxiosConfig } from '../configuration';


@injectable()
export class InvoicesApiService {

    protected basePath = '';
    protected configuration = new Configuration();

    constructor(@inject(BASE_PATH) @optional() basePath: string, @optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }


    @observable
    public downloadPrintAgreementObservable: string | undefined = undefined;

    /**
     * 
     * 
     * @param fileName 
     */
    @action
    public downloadPrintAgreement(fileName?: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<string> {

        const queryParameters: {[index: string]: any} = {};
        if (fileName !== undefined) {
            queryParameters['fileName'] = fileName;
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<string>(
            `${this.basePath}/api/invoices/agreement`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.downloadPrintAgreementObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public downloadPrintInvoiceObservable: string | undefined = undefined;

    /**
     * 
     * 
     * @param id 
     */
    @action
    public downloadPrintInvoice(id: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<string> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling downloadPrintInvoice.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<string>(
            `${this.basePath}/api/invoices/print/${encodeURIComponent(String(id))}`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.downloadPrintInvoiceObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public downloadPrintInvoiceSignatureObservable: string | undefined = undefined;

    /**
     * 
     * 
     * @param invoiceSignatureId 
* @param visitActionRequestId 
     */
    @action
    public downloadPrintInvoiceSignature(invoiceSignatureId: string, visitActionRequestId?: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<string> {
        if (invoiceSignatureId === null || invoiceSignatureId === undefined) {
            throw new Error('Required parameter invoiceSignatureId was null or undefined when calling downloadPrintInvoiceSignature.');
        }

        const queryParameters: {[index: string]: any} = {};
        if (visitActionRequestId !== undefined) {
            queryParameters['visitActionRequestId'] = visitActionRequestId;
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<string>(
            `${this.basePath}/api/invoices/invoice-signature-request/${encodeURIComponent(String(invoiceSignatureId))}/print`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.downloadPrintInvoiceSignatureObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public downloadPrintProjectSignatureObservable: string | undefined = undefined;

    /**
     * 
     * 
     * @param projectSignatureId 
* @param visitActionRequestId 
     */
    @action
    public downloadPrintProjectSignature(projectSignatureId: string, visitActionRequestId?: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<string> {
        if (projectSignatureId === null || projectSignatureId === undefined) {
            throw new Error('Required parameter projectSignatureId was null or undefined when calling downloadPrintProjectSignature.');
        }

        const queryParameters: {[index: string]: any} = {};
        if (visitActionRequestId !== undefined) {
            queryParameters['visitActionRequestId'] = visitActionRequestId;
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<string>(
            `${this.basePath}/api/invoices/project-signature-request/${encodeURIComponent(String(projectSignatureId))}/print`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.downloadPrintProjectSignatureObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public getInvoiceByIdObservable: Invoice | undefined = undefined;

    /**
     * 
     * 
     * @param id 
     */
    @action
    public getInvoiceById(id: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<Invoice> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getInvoiceById.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<Invoice>(
            `${this.basePath}/api/invoices/${encodeURIComponent(String(id))}`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.getInvoiceByIdObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public getInvoicesObservable: Array<Invoice> | undefined = undefined;

    /**
     * 
     * 
          */
    @action
    public getInvoices(showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<Array<Invoice>> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<Array<Invoice>>(
            `${this.basePath}/api/invoices`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.getInvoicesObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public getInvoicesByLocationObservable: Array<InvoicesByLocation> | undefined = undefined;

    /**
     * 
     * 
          */
    @action
    public getInvoicesByLocation(showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<Array<InvoicesByLocation>> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<Array<InvoicesByLocation>>(
            `${this.basePath}/api/invoices/invoices-by-location`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.getInvoicesByLocationObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public signInvoiceObservable: any = undefined;

    /**
     * 
     * 
     * @param visitActionId 
* @param body 
     */
    @action
    public signInvoice(visitActionId: string, body?: SignInvoiceRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<any> {
        if (visitActionId === null || visitActionId === undefined) {
            throw new Error('Required parameter visitActionId was null or undefined when calling signInvoice.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<any>(
            `${this.basePath}/api/invoices/${encodeURIComponent(String(visitActionId))}/sign`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.signInvoiceObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public signProjectObservable: any = undefined;

    /**
     * 
     * 
     * @param visitActionId 
* @param body 
     */
    @action
    public signProject(visitActionId: string, body?: ProjectSignatureRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<any> {
        if (visitActionId === null || visitActionId === undefined) {
            throw new Error('Required parameter visitActionId was null or undefined when calling signProject.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<any>(
            `${this.basePath}/api/invoices/${encodeURIComponent(String(visitActionId))}/projects/sign`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.signProjectObservable = response.data);
            }
            return response;
        });
    }

}
